(() => {
    let carousels = document.querySelectorAll(
        '.js-link-collection-carousel.-key-figures-carousel'
    );

    if (!carousels.length) {
        return;
    }

    carousels.forEach(function (splideElement) {
        const args = {
            type: 'loop',
            focus: 'center',
            autoScroll: false,
            arrows: true,
            //autoWidth: true,
            perMove: 1,
            pagination: false,
            arrowPath: ' ',
            mediaQuery: 'min',
            breakpoints: {
                0: {
                    perPage: 1,
                    gap: 'clamp(1rem, 3vw, 2rem)',
                },
                500: {
                    perPage: 1.5,
                    gap: 'clamp(1.5rem, 3vw, 2.5rem)',
                },
                950: {
                    perPage: 2,
                    gap: '2.5rem',
                },
                1120: {
                    perPage: 1.5,
                    gap: '3.5rem',
                },
                1170: {
                    perPage: 2,
                    gap: '3.5rem',
                },
                1440: {
                    perPage: 2.5,
                    gap: '3.5rem',
                },
                1640: {
                    perPage: 3,
                    gap: '4rem',
                },
            },
            i18n: H_Tools.carousel?.getLabels(splideElement),

            autoplay: 'pause',
            intersection: {
                inView: {
                    autoplay: true,
                },
                outView: {
                    autoplay: false,
                },
            },
        };

        let splide = new Splide(splideElement, args);

        // Store a reference to the Splide object
        H_Tools.carousel[splideElement.getAttribute('data-carousel-id')] =
            splide;

        H_Tools.carousel?.addListeners(splide, splideElement);

        splide.mount(window.splide.Extensions);
    });
})();
